import React, { PropTypes } from "react";
import Component from "react-pure-render/component";
import { findDOMNode } from "react-dom";
import { DragSource, DropTarget } from "react-dnd";
import DragLayer from "../components/dragLayer.react";
import InputCustom from "../components/inputCustom.react";
import Modal from "../components/modal.react";

const itemTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().itemUID;
    const hoverIndex = props.itemUID;

    if (dragIndex === hoverIndex) {
      return;
    }

    const { setHoveringItemUID, hoveringItemUID } = props;
    setHoveringItemUID(hoverIndex);

    if (hoverIndex === hoveringItemUID) {
      return;
    }

    const { moveAction, moveActionProps } = props;
    if (moveAction) {
      moveAction(dragIndex, hoverIndex, moveActionProps);
    }
  }
};

function getTypes(props) {
  return props.types;
}

class FieldDragAndDrop extends Component {
  static propTypes = {
    connectDropTarget: PropTypes.func.isRequired,
    itemUID: PropTypes.string.isRequired,
    types: PropTypes.string.isRequired,
    setHoveringItemUID: PropTypes.func.isRequired,
    hoveringItemUID: PropTypes.string.isRequired,
    moveAction: PropTypes.func,
    moveActionProps: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.wrapperWidth = 0;
    this.getElementWrapperWidth = this.getElementWrapperWidth.bind(this);
  }

  componentDidMount() {
    this.getElementWrapperWidth();
    window.addEventListener("resize", this.getElementWrapperWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.getElementWrapperWidth);
  }

  getElementWrapperWidth() {
    const { elementWrapper } = this.refs;
    this.wrapperWidth = findDOMNode(
      elementWrapper
    ).getBoundingClientRect().width;
  }

  render() {
    const { connectDropTarget } = this.props;
    const width = "100%";

    return connectDropTarget(
      <div style={{ width }}>
        <div style={{ width }} ref="elementWrapper">
          <div className="col-xs-12">
            <div className="dropzone">
              <div className="dropzone-text">Drop here</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default DropTarget(getTypes, itemTarget, connect => ({
  connectDropTarget: connect.dropTarget()
}))(FieldDragAndDrop);



// WEBPACK FOOTER //
// ./src/browser/template/emptyDropTarget.react.js